<template>
    <div class="container">
        <div class="gallery-container">
        <svg id="left-arrow" @click="dec()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
            <circle cx="50" cy="50" r="49" stroke="white" stroke-width="2"/>
            <path d="M29 21L72 50.4915L31 79" stroke="white" stroke-width="2"/>
        </svg>
        <div class="gallery">
            <div v-for="n in lstImages" :key="n">
                <transition appear name="fade" mode="out-in">
                    <img :src="images[n]" v-on:click="selectedImage=images[n]" alt="" srcset="">
                </transition>
            </div>
        </div>
        <svg id="right-arrow" @click="inc()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
            <circle cx="50" cy="50" r="49" stroke="white" stroke-width="2"/>
            <path d="M29 21L72 50.4915L31 79" stroke="white" stroke-width="2"/>
        </svg>
        </div>
        <transition name="fade">
            <div class="lightbox" v-if="selectedImage" v-on:click="selectedImage=null">
                <div class="close-btn">
                    <div></div>
                    <div></div>
                </div>
                <img :src="selectedImage">
            </div>
        </transition>
        <div class="button" v-on:click="selectedImage=lookbook">Afficher le lookbook</div>
    </div>
</template>

<script>
export default {
    name: "Gallery",
    props: {
        images: Array,
        title: String,
        lookbook: String,
        credits: Array
    },
    beforeMount: function() {
        let width = window.innerWidth;
        if (width <= 700) {
            this.n_max = 1;
            this.lstImages = [...Array(1).keys()];
        } else if (width <= 1000) {
            this.n_max = 2;
            this.lstImages = [...Array(2).keys()];
        } else if (width <= 1300) {
            this.n_max = 3;
            this.lstImages = [...Array(3).keys()];
        }
    },
    watch: {
        images: function() {
            this.$data.max = this.images.length;
            this.$data.lstImages = [...Array(4).keys()];
            let width = window.innerWidth;
            if (width <= 700) {
                this.n_max = 1;
                this.lstImages = [...Array(1).keys()];
            } else if (width <= 1000) {
                this.n_max = 2;
                this.lstImages = [...Array(2).keys()];
            } else if (width <= 1300) {
                this.n_max = 3;
                this.lstImages = [...Array(3).keys()];
            }
        }
    },
    data: function() {
        return {
            i : 0,
            max: this.images.length,
            n_max: 4,
            lstImages: [...Array(4).keys()],
            selectedImage: null,
        }
    },
    methods: {
        inc : function() {
            this.lstImages = this.lstImages.map((n) => {
                if (n === this.max - 1)
                    return 0;
                return n + 1;
            });
        },
        dec : function() {
            this.lstImages = this.lstImages.map((n) => {
                if (n === 0)
                    return this.max - 1;
                return n - 1;
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.button {
    user-select: none;
    border: solid 0.1rem white;
    border-radius: 5px;
    margin: 0.5rem;
    padding: 0.4rem;
    &:hover {
        cursor: pointer;
        color: black;
        background-color: white;
        border-color: black;
    }
}
.lightbox {
    z-index: 100;
    position: fixed;
    top: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: scroll;
    img {
        height: auto;
        width: 100%;
    }
    $square : 50px;
    div.close-btn {
        height: $square;
        width: $square;
        position: absolute;
        right: 1rem;
        top: 1rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        height: $square;
        width: $square;
        border: 1px solid #dcdcdc;
        z-index: 99;
        div {
            position: relative;
            width: 85%;
            height: 4px;
            top: 50%;
            background: #dcdcdc;
            border-radius: 0.2em;
            &:nth-of-type(1) {
                transform: translateY(-2px)rotate(-45deg);
            }
            &:nth-of-type(2) {
                transform: translateY(-6px) rotate(45deg);
            }
        }
    }
}

.fade-enter-active {
  transition: opacity .7s;
}
.fade-leave-active {
    transition: opacity .7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

div.gallery-container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100%;
}
div.container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    div.gallery {
        display: flex;
        flex-direction: row;
        img {
            width: 100%;
            height: auto;
            user-select: none;
            cursor: pointer;
        }
    }
    $strokewidth: 5;
    $square : 100px + $strokewidth;
    svg {
        z-index: 10;
        background-color: transparent;
        cursor: pointer;
        width: $square;
        height: $square;
        circle {
            r: calc(#{$square} / 2 - #{$strokewidth});
        }
        & > circle, path {
            stroke: black;
            stroke-width: $strokewidth;
        }
        &#left-arrow {
            transform: rotate(180deg) translateX(-50px) scale(1.8);
        }
        &#right-arrow {
            transform: translateX(-50px) scale(1.8);
        }
    }
}

@media screen and (min-width: 600px) {
    .lightbox {
        img {
            height: 96%;
            width: auto;
        }
    }
    $strokewidth: 2;
    $square : 100px + $strokewidth;
    div.container {
        div.gallery {
            display: flex;
            flex-direction: row;
            img {
                width: 310px;
                height: auto;
                padding: 1rem;
            }
            
            
        }
        svg {
            & > circle, path {
                stroke: white;
                stroke-width: $strokewidth;
            }
            &#left-arrow {
                transform: rotate(180deg) scale(0.6);
            }
            &#right-arrow {
                transform: translateX(0) scale(0.6);
            }
        }
    }
}
</style>
